<template>
  <div class="bg-white rounded-lg shadow-md p-6 mb-6 text-center">
    <h1 class="text-center text-3xl font-bold mb-6">Ingresso confermato!</h1>
    <p>Grazie!</p>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import LayoutNoHeader from '@/Layouts/LayoutNoHeader.vue';

export default {
  layout: LayoutNoHeader,
  mounted() {
    setTimeout(() => {
      router.visit(route('modules.home', { slug: 'reception-digitale'}));
    }, 5000);
  }
};
</script>